(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sr-all-collections-carousels"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialiseCarousel = (carousel) => {
      if (carousel.dataset.srCarouselReady === 'true') return;

      const track = carousel.querySelector('[data-sr-carousel-track]');
      const previousButton = carousel.querySelector('[data-sr-carousel-previous]');
      const nextButton = carousel.querySelector('[data-sr-carousel-next]');

      if (!track || !previousButton || !nextButton) return;

      carousel.dataset.srCarouselReady = 'true';
      let updateQueued = false;

      const updateButtons = () => {
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maximumScroll - 2;
        updateQueued = false;
      };

      const queueUpdate = () => {
        if (updateQueued) return;
        updateQueued = true;
        window.requestAnimationFrame(updateButtons);
      };

      const moveCarousel = (direction) => {
        const firstCard = track.querySelector('.grid-product');
        const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : track.clientWidth;
        const cardsPerMove = window.matchMedia('(min-width: 750px)').matches ? 2 : 1;

        track.scrollBy({
          left: direction * (cardWidth + gap) * cardsPerMove,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };

      previousButton.addEventListener('click', () => moveCarousel(-1));
      nextButton.addEventListener('click', () => moveCarousel(1));
      track.addEventListener('scroll', queueUpdate, { passive: true });
      window.addEventListener('resize', queueUpdate, { passive: true });
      updateButtons();
    };

    const initialiseCatalog = (root = document) => {
      root.querySelectorAll('[data-sr-carousel]').forEach(initialiseCarousel);
    };

    initialiseCatalog();
    document.addEventListener('shopify:section:load', (event) => initialiseCatalog(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sr-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
  var bars = document.querySelectorAll('[data-sr-sticky-atc]:not([data-sr-ready])');

  bars.forEach(function (bar) {
    bar.setAttribute('data-sr-ready', 'true');

    var productSection = document.getElementById(
      'ProductSection-' + bar.getAttribute('data-section-id') + '-' + bar.getAttribute('data-product-id')
    );
    var stickyButton = bar.querySelector('[data-sr-sticky-button]');
    var stickyText = bar.querySelector('[data-sr-sticky-text]');
    var stickyPrice = bar.querySelector('[data-sr-sticky-price]');

    if (!productSection || !stickyButton) {
      return;
    }

    var originalButton = productSection.querySelector('[data-add-to-cart]');
    var originalText = productSection.querySelector('[data-add-to-cart-text]');
    var originalPrice = productSection.querySelector('[data-product-price]');

    if (!originalButton) {
      return;
    }

    function syncBar() {
      stickyButton.disabled = originalButton.disabled;
      if (originalText && stickyText) {
        stickyText.textContent = originalText.textContent.trim();
      }
      if (originalPrice && stickyPrice) {
        stickyPrice.textContent = originalPrice.textContent.trim();
      }
    }

    function setVisible(visible) {
      if (visible) {
        bar.hidden = false;
        requestAnimationFrame(function () {
          bar.classList.add('is-visible');
        });
      } else {
        bar.classList.remove('is-visible');
        bar.hidden = true;
      }
    }

    stickyButton.addEventListener('click', function () {
      if (!originalButton.disabled) {
        originalButton.click();
      }
    });

    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var hasPassedButton = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      setVisible(hasPassedButton);
    }, { threshold: 0 });

    observer.observe(originalButton);

    var mutationObserver = new MutationObserver(syncBar);
    mutationObserver.observe(originalButton, { attributes: true, childList: true, subtree: true });
    if (originalPrice) {
      mutationObserver.observe(originalPrice, { childList: true, subtree: true, characterData: true });
    }

    productSection.addEventListener('change', function () {
      requestAnimationFrame(syncBar);
    });

    syncBar();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
